import { render, staticRenderFns } from "./Wuliu.vue?vue&type=template&id=4b63426e&scoped=true"
import script from "./Wuliu.vue?vue&type=script&lang=js"
export * from "./Wuliu.vue?vue&type=script&lang=js"
import style0 from "./Wuliu.vue?vue&type=style&index=0&id=4b63426e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63426e",
  null
  
)

export default component.exports